import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid } from '@material-ui/core';
import "./Breakdown.css";
import { useLocation, useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';
import PowerIcon from '@material-ui/icons/Power';
import { getBreakdowns } from '../../ReduxStore/Breakdown/BreakdownSlice';
import { useDispatch } from 'react-redux';
// import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import { convertUTCtoIST } from '../../helpers/DateConvert';


const BreakdownHistory = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const pathname = location.pathname.split('/');
    const asset_id = pathname[3]
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Breakdown Management', href: '/breakdown-management' },
        { label: 'Current Breakdown', href: '/breakdown-management/current-breakdowns' },
    ];

    const [loading, setLoading] = useState(true);
    const [breakDowns, setBreakdowns] = useState([]);
   

    // const getPriorityClass = (priority) => {
    //     switch (priority.toLowerCase()) {
    //         case 'high':
    //             return 'high-priority';
    //         case 'medium':
    //             return 'medium-priority';
    //         case 'low':
    //             return 'low-priority';
    //         default:
    //             return '';
    //     }
    // };


    // const reports = JSON.parse(localStorage.getItem("report")) || [];
    // const selectedReports = reports.filter(report => report.assetNo === assetNo);




    const handler = (item) => {
        navigate(`/breakdown-details/${item.id}`)
    }
    const getBreakDowns = async () => {
        try {
            const action = dispatch(getBreakdowns(`?machine_id=${asset_id}`));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                setBreakdowns(res.result.breakdowns);
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            // toast.error(error.message || "Something went wrong!");
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            await getBreakDowns();
            setLoading(false);
        };
        fetchData();
    }, [])

    if (loading) {
        return (
          <Layout>
            <Container>
              <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                <GridLoadingSpinner />
              </Box>
            </Container>
          </Layout>
        );
      }

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h3" component="h1" gutterBottom>
                        Breakdown History
                    </Typography>
                </Box> */}
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Breakdown History" />
                </Box>
                <Box mb={2}>
                    {breakDowns.length === 0 ? (
                        <Box display="flex" alignItems="center" justifyContent="center" mt={4}>
                            <PowerIcon style={{ fontSize: 40, marginRight: 8 }} />
                            <Typography variant="h5">No Current Breakdown</Typography>
                        </Box>
                    ) : (<Grid container spacing={4}>
                        {breakDowns && breakDowns.map((item, index) => (
                            <Grid item xs={12} sm={3} key={index} onClick={() => handler(item)}>
                                <div className='breakdown-card'>
                                    <div className='card-header' style={{ color: 'black' }}>
                                        <span >
                                            <PowerIcon />
                                        </span>
                                        {item.name}
                                    </div>
                                    <h4>{item.machine_details.asset_text}</h4>
                                    <p><span>Category:</span> {item.reason.category_name}</p>
                                    <p><span>Reason:</span> {item.reason.name}</p>
                                    <p><span>Priority:</span> {item.priority}</p>
                                    <p><span>Status:</span> {item.status}</p>
                                    <p><span>Reported by:</span> {item.reported_by}</p>
                                    <p><span>Reported at:</span> {convertUTCtoIST(item.reported_at)}</p>
                                    {item.attended_by && (
                                        <p><span>Attended by:</span> {item.attended_by}</p>
                                    )}
                                </div>
                            </Grid>
                        ))}


                    </Grid>)}

                </Box>
            </Container>
        </Layout >
    );
};

export default BreakdownHistory;
